import { useAccountSwitcherUiAPIInterfaceNew } from "@dealer-center/ddc-pages-account-switcher-ui-fetch";
import {
  Alert,
  Box,
  RichTreeView,
  Typography
} from "@dealer-center/core-components";
import { LoadingIndicator } from "@dealer-center/core-custom-components";
import { Outlet, useParams } from "react-router-dom";

export const PagesAccountSwitcherUiUiResultsNew = () => {
  const { searchValue } = useParams();
  const { data, error, isLoading } = useAccountSwitcherUiAPIInterfaceNew({
    searchValue
  });

  if (error)
    return (
      <Alert role="alert" sx={{ marginBottom: "16px" }} type="error">
        {error.message}
      </Alert>
    );

  if (isLoading)
    return (
      <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
        <LoadingIndicator
          actionName="Loading PagesAccountSwitcherUiUi"
          text="Loading"
        />
      </Box>
    );

  return (
    <Box sx={{ pt: 4 }}>
      <Typography variant={"h2"}>{data?.ddcId}</Typography>
      <Typography variant={"h3"}>DDC</Typography>
      <RichTreeView items={data?.ddcIds || []} />
      <Typography variant={"h4"}>SVOC</Typography>
      <RichTreeView items={data?.svocIds || []} />

      <Outlet />
    </Box>
  );
};
